module.exports = __webpack_public_path__ + "3f3466f02a08c078e2db7f2c9999d585.pdf";